import { Component, Optional, ViewEncapsulation } from '@angular/core';
import { Panel } from 'app/utils/panel';
import { ReputationService } from 'app/services/reputation';
import { LicenseService } from 'app/services/license';
import { EulaService } from 'app/components/eula/eula.service';
import { UserFeaturesStatusService } from 'app/services/user-features-status';
import { I360Config } from 'app/utils/config/config';
import { HistoryService } from 'app/services/history';
import { AppState } from 'app/core/app.service';
import { fromEvent, bufferCount, filter, map } from 'rxjs';
import { I360ConfigDataItems } from '@imunify360-api/settings';
import { EmailsService } from 'app/services/emails';


@Component({
    templateUrl: './app.component.html',
    providers: [
        I360Config,
    ],
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
    support = this.config.changes.pipe(
        map((c: I360ConfigDataItems) =>  c.PERMISSIONS.support_form),
    );

    constructor(
        public panel: Panel,
        public emailsService: EmailsService,
        public historyService: HistoryService,
        public appState: AppState,
        @Optional() public licenseService: LicenseService,
        @Optional() public eulaService: EulaService,
        // looks like component level providers are lazy loaded
        @Optional() public reputationService: ReputationService,
        @Optional() public userFeaturesStatus: UserFeaturesStatusService,
        public config: I360Config,
    ) {
         //  Need for iframe in DirectAdmin panel
        if (this.panel.isDirectAdmin && document.querySelector('#iframe-container')) {
            fromEvent(window, 'mousemove').pipe(
                map((event: MouseEvent) => event.clientY),
                bufferCount(20, 1),
                filter((clientY) => {
                    return ((this.appState.mousePositonY + 30  < clientY[0]) ||
                        (this.appState.mousePositonY - 30 > clientY[0]));
                }),
            ).subscribe((position) => {
                this.appState.mousePositonY = position[0];
            });
        }
    }
}
